import {
    FaCrown,
    FaCalendarAlt,
    FaLockOpen,
    FaGift,
} from "react-icons/fa";

import styles from "./TrialStatusCard.module.css";

const TrialStatusCard = ({
    plan = "trial",
    remainingDays = 0,
    expireDate = "",
    onUpgrade,
}) => {

    if (plan === "free") {

        return (

            <section
                className={`${styles.card} ${styles.freeCard}`}
            >

                <div className={styles.header}>

                    <div className={styles.title}>

                        <FaGift />

                        <span>
                            نسخه رایگان
                        </span>

                    </div>

                    <span
                        className={`${styles.badge} ${styles.badgeFree}`}
                    >
                        FREE
                    </span>

                </div>

                <div className={styles.message}>

                    اکنون برنامه در حالت رایگان قرار دارد.

                </div>

                <ul className={styles.features}>

                    <li>تعریف یک خودرو</li>

                    <li>تعریف سرویس تعویض روغن موتور</li>

                    <li>ثبت سابقه سرویس</li>

                    <li>نمایش آخرین سابقه سرویس</li>

                </ul>

                <button
                    type="button"
                    className={styles.upgradeButton}
                    onClick={onUpgrade}
                >

                    فعال‌سازی اشتراک حرفه‌ای

                </button>

            </section>

        );

    }

    if (plan === "pro") {

        return (

            <section
                className={styles.card}
            >

                <div className={styles.header}>

                    <div className={styles.title}>

                        <FaCrown />

                        <span>

                            اشتراک حرفه‌ای فعال

                        </span>

                    </div>

                    <span className={styles.badge}>

                        PRO

                    </span>

                </div>

                <div className={styles.progress}>

                    <div
                        className={styles.progressBar}
                        style={{
                            width: `${Math.min(
                                100,
                                (remainingDays / 365) * 100
                            )}%`,
                        }}
                    />

                </div>

                <div className={styles.info}>

                    <div className={styles.days}>

                        {remainingDays}

                        <small>

                            روز باقی مانده

                        </small>

                    </div>

                    <div className={styles.expire}>

                        <FaCalendarAlt />

                        <span>

                            {expireDate}

                        </span>

                    </div>

                </div>

            </section>

        );

    }

    // Trial

    return (

        <section
            className={`${styles.card} ${styles.trialCard}`}
        >

            <div className={styles.header}>

                <div className={styles.title}>

                    <FaLockOpen />

                    <span>

                        دوره آزمایشی فعال

                    </span>

                </div>

                <span
                    className={`${styles.badge} ${styles.badgeTrial}`}
                >

                    TRIAL

                </span>

            </div>

            <div className={styles.progress}>

                <div
                    className={styles.progressBar}
                    style={{
                        width: `${Math.min(
                            100,
                            (remainingDays / 30) * 100
                        )}%`,
                    }}
                />

            </div>

            <div className={styles.info}>

                <div className={styles.days}>

                    {remainingDays}

                    <small>

                        روز باقی مانده

                    </small>

                </div>

                <div className={styles.expire}>

                    <FaCalendarAlt />

                    <span>

                        {expireDate}

                    </span>

                </div>

            </div>

            <div className={styles.message}>

                در طول دوره آزمایشی تمام امکانات برنامه بدون هیچ محدودیتی در اختیار شماست.

            </div>

        </section>

    );

};

export default TrialStatusCard;
